import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import debounce from 'lodash.debounce';

// Components
import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';
import ArsMap from 'components/_shared/ArsMap/ArsMap';
import ProviderFilter from 'components/Directory/ProviderFilter/ProviderFilter';
// import ProviderList from 'components/Directory/ProviderList/ProviderList';
import SearchInput from 'components/_shared/SearchInput/SearchInput';
// import Tooltip from 'components/_shared/Tooltip/Tooltip';
import Banner from 'components/Banner/Banner';

// SVGs
import Verified from "images/verified.png"

// Constants
import { staticData } from 'constants/constants';

// Redux Actions
import { setSearch, resetFilter } from 'store/modules/db/search/searchReducer';

// Styles
import './Directory.css';

const mapStateToProps = state => ({
  visibilityData: state.app.visibility.visibility,
  artworxProviders: state.db.providers.providers,
  locations: state.db.locations.locations,
  search: state.db.search
});

export class Directory extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {
    recent: PropTypes.arrayOf(PropTypes.object)
  };
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    currentProvider: null,
    visibleProviders: [],
    mapView: false,
    options: false,
    overlay: {
      spa: false,
      hood: false
    },
    refresh: false,
    search: '',
    locationSearch: '',
    filters: {
      organizational: [],
      creative: [],
      pipeline: [],
      ages: [],
      populations: [],
      individuals: [],
      community: [],
      affiliated: []
    },
    // Los Angeles
    lat: 34.0522,
    lng: -118.2437,
    zoom: 11,
    tooltip: false
  }

  searchResults = [];

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    this.getAllData();
    if (this.props.search.search && this.props.search.search.length) {
      this.handleInputOnMount('search', this.props.search.search)
      this.props.dispatch(setSearch({ search: '' }));
    }

    if (this.props.search.filter && this.props.search.filter.type.length) {
      this.handleInputOnMount('filter', this.props.search.filter)
      this.props.dispatch(resetFilter());
    }

  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.visibilityData.verifiedTooltip && !this.state.tooltip && this.providerListRef && this.scrollRef) {
  //     console.log('check scrollRef', this.verifiedRef.getBoundingClientRect())
  //     this.providerListRef.scrollTo(0, this.scrollRef.offsetTop - 850);
  //     this.setState({tooltip: true})
  //   }
  // }

  componentWillUnmount() {
    this.props.dispatch(setSearch({ search: '' }));
    this.props.dispatch(resetFilter());
  }

  // Event handlers
  // ------------------------------------------------------------------------ //
  handleMapView = flag => {
    if (this.state.mapView !== flag) {
      this.setState({ mapView: flag });
    }
  }

  chooseProvider = (e, providerKey, geoPosition) => {
    if (e) e.preventDefault();
    this.setState({currentProvider: providerKey}, () => {
      if (geoPosition) {
        this.setLocation({
          lat: +geoPosition.lat,
          lng: +geoPosition.lng
        });
      }
    })
  }

  setLocation = locationData => {
    const {lat, lng} = locationData;
    this.setState({
      lat,
      lng
    });
  }

  showOptions = e => {
    // if (e) e.preventDefault();
    this.setState({options: !this.state.options})
  }

  toggleCheckbox = (e, type) => {
    // if (e) e.preventDefault();
    this.setState({[type]: !this.state[type]})
  }

  toggleOverlay = (e, type) => {
    // if (e) e.preventDefault();
    this.setState({overlay: {[type]: !this.state.overlay[type]}})
  }

  handleFilter = (e, filterCandidate) => {
    let type = filterCandidate.type;
    let filters = { ...this.state.filters };

    if (filters[type].indexOf(filterCandidate.filter) > -1) {
      filters[type] = filters[type].filter(fltr => fltr !== filterCandidate.filter);
    } else {
      filters[type] = filters[type].concat(filterCandidate.filter)
    }
    this.setState({ filters });
  }

  resetFilters = e => {
    let filters = { ...this.state.filters };
    let resetFilters = Object.keys(filters).reduce(
      (all, curr) => {
        all[curr] = [];
        return all;
      }, {}
    )
    this.setState({ filters: resetFilters })
  }

  applyFilters = e => {
    this.setState({ options: false })
  }

  // search methods
  handleActiveSearch = e => {
    if (e) e.preventDefault();

    let searchResults = this.state.search.length ? this.props.artworxProviders.filter(
      provider => provider.organization.toLowerCase().indexOf(this.state.search) > -1
    ) : [];

    let locationResults = this.state.locationSearch.length ? this.props.artworxProviders.reduce(
      ( providers, currProvider ) => {
        let contact = currProvider.contact.find(
          con => (con.address
            && con.city
            && `${con.address}, ${con.city}`.toLowerCase().indexOf(this.state.locationSearch) > -1
          )
        )
        return contact ? providers.concat(currProvider) : providers
      }, []
    ) : [];

    switch(true) {
      case this.state.search.length + this.state.locationSearch.length === 0:
        this.searchResults = [];
        break;
      case this.state.search.length > 0 && this.state.locationSearch.length > 0:
        this.searchResults = this.findUnion(searchResults, locationResults)
        break;
      case this.state.search.length > 0:
        this.searchResults = searchResults.length ? searchResults : null;
        break;
      case this.state.locationSearch.length > 0:
        this.searchResults = locationResults.length ? locationResults : null;
        break;
      default:
        break;
    }
    return this.forceUpdate();
  };

  findUnion = (list1, list2) => {
    let long = list1.length >= list2.length ?
      list1
    :
      list2;

    let short = list1.length < list2.length ?
      list1
    :
      list2;

    return long.filter(
      a => short.some( b => a.organization === b.organization )
    );
  }

  triggerActiveSearch = (type, value) => {
    this.setState({ [type]: value.toLowerCase() }, () => {
      this.handleActiveSearch(null);
    });
  };

  handleInputChange = (e, type) => {
    this.triggerActiveSearch(type, e.target.value);
  };

  handleInputOnMount = (type, value) => {
    if (type === 'search') {
      this.triggerActiveSearch(type, value);
    } 

    if (type === 'filter') {
      this.handleFilter(null, {
        type: value.type,
        filter: value.query
      })
    }
  };


  // Class methods
  // ------------------------------------------------------------------------ //
  getAllData = async () => {
    if (!this.props.artworxProviders.length) {
      await this.props.getProviders()
    }

    if (!Object.keys(this.props.locations).length) {
      await this.props.getLocations()
    }
  }

  filterProviders = provider => {
    let { filters } = this.state;

    return Object.keys(filters)
      .filter(filt => filters[filt].length)
      .every(filt => {
        return filters[filt].every(
          fltr => {
            return provider[filt].indexOf(fltr) > -1
          }
        )
    })
  }

  searchProviders = provider => {
    if (!this.searchResults) {
      return false;
    }

    let result = true;

    if (this.searchResults.length) {
      result = this.searchResults.some(result => result.organization === provider.organization)
    }
    return result;
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  // renderVerified = provider => {
  //   return provider.organization === 'artworxLA' ? (
  //     <Tooltip
  //       ref={ref => this.tooltipRef = ref}
  //       onClick={() => console.log('click verified tooltip')}>
  //     <div className="provider__verified">
  //       <img src={Verified} alt="verified"/>
  //     </div>
  //   </Tooltip>)
  //   :
  //   (<div className="provider__verified">
  //     <img src={Verified} alt="verified"/>
  //   </div>)
  // }

  renderProvider = ( provider, contactsLen, location, idx ) => {
    let providerKey = `${Date.parse(provider.timestamp)}_${idx}`;
    return (
      <li
      key={providerKey}
      ref={ ref => provider.organization === 'artworxLA' ? this.scrollRef = ref : null}
      className={`
          provider__container
          ${this.state.currentProvider === providerKey ? 'provider--active' : ''}
          `}
      onClick={e => this.chooseProvider(e, providerKey, location.geoPosition)}
      >
      <div className="provider">
      <Link className={`provider__title`} to={`/details/${provider.organization}`}>{`${provider.organization}${contactsLen > 1 ? (` - ${location.title || location.city.slice(-5)}`) : ''}`}</Link>
      <p className={`provider__address`}>{location.address}</p>
      <p className={`provider__city`}>{location.city}</p>
      <p className={`provider__phone`}>{location.telephone}</p>
      </div>
      {provider.interviewed.toLowerCase() === 'yes' ?
        (<div 
          className="provider__verified">
          <img 
            ref={ref => this.verifiedRef = ref}
            src={Verified} alt="verified"/>
        </div>) : null}

      </li>
    )
  }

  adjustProvidersVisibility = () => {
    return this.props.artworxProviders
      .filter(this.searchProviders)
      .filter(this.filterProviders)
  }

  renderProviders = () => {
    let showProviders = this.adjustProvidersVisibility();

    if (!showProviders.length) {
      return (<li className={`provider__container`}>No Matching Results</li>)
    }

    return showProviders
      .sort((a,b) => {
        let aVal = String(a.organization);
        let bVal = String(b.organization);
        let n = a - b;
        return !isNaN(n) ? n : aVal.localeCompare(bVal);
      })
      .map(provider => {
        let contactsLen = provider.contact.length;
        return provider.contact.map((location, idx) => {
          return this.renderProvider(provider, contactsLen, location, idx);
        })
      })
  }

  render() {
    if (!this.props.artworxProviders.length || !Object.keys(this.props.locations).length) {
      return <div className={`directory directory--requesting`}></div>
    }

    return (
      <ErrorBoundary>
        <div className={`directory`}>
          <div className="directory__container">
            <section className={`
              providers
              ${this.state.mapView ? "providers--no-vis" : ""}
              `}>
              <div className="providers__search">
                <SearchInput
                  className="providers__search-name"
                  type="search"
                  name="search"
                  placeholder="Search by Organization Name"
                  value={this.state.search}
                  onChange={e => this.handleInputChange(e, 'search')}
                />
                <SearchInput
                  className="providers__search-address"
                  name="search"
                  placeholder="Search by Location"
                  value={this.state.locationSearch}
                  onChange={e => this.handleInputChange(e, 'locationSearch')}
                />
              </div>
              <div className="providers__results">
                <div className="providers__results-title"><p>Search Results</p></div>
                <div
                  className={`
                    providers__results-options
                    ${this.state.options ? "providers__results-options--show" : ""}
                    `}
                  onClick={this.showOptions}
                >
                  <p>Filters</p>
                </div>
              </div>
              { this.state.options ?
                (<ProviderFilter
                    refresh={this.state.refresh}
                    overlayData={this.state.overlay}
                    toggleOverlay={this.toggleOverlay}
                    toggleCheckbox={this.toggleCheckbox}
                    handleFilter={this.handleFilter}
                    staticData={staticData}
                    filters={this.state.filters}
                    resetFilters={this.resetFilters}
                    applyFilters={this.applyFilters}
                  />)
                :
                (<ul
                  className={`providers__list`}
                  ref={ref => this.providerListRef = ref}>
                  { this.renderProviders() }

                  {/*this.state.tooltip &&
                    (<Tooltip
                      placement={{top: '295px', left: `${this.verifiedRef.getBoundingClientRect().left - 100 - this.verifiedRef.getBoundingClientRect().width}px`}}
                      onClick={() => console.log('click verified tooltip')}/>)*/}
                      </ul>)
              }
            </section>
            <ArsMap
              fullSize={this.state.mapView}
              handleMapView={this.handleMapView}
              providers={this.adjustProvidersVisibility()}
              geoData={this.props.locations}
              location={[ this.state.lat, this.state.lng ]}
              setLocation={this.setLocation}
              zoom={this.state.zoom}
              overlay={this.state.overlay}
              currentProvider={this.state.currentProvider} />

          </div>
          <Banner />
        </div>
      </ErrorBoundary>
    );
  }
}

              // providers={this.props.artworxProviders}
export default connect(mapStateToProps)(Directory);



// WEBPACK FOOTER //
// ./src/components/Directory/Directory.js